import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';

import ErrorMessage from '../error_message/ErrorMessage';

import dataLayer from '../../../utils/dataLayer';

import './InsuredRegister.css';

import incomingOptions from './incomingOptions.json';

class InsuredForm extends Component {
  constructor(props) {
    super(props);

    this.handleChangeRemoveInsured = this.handleChangeRemoveInsured.bind(this);

    this.state = {
      isOpened: false,
    };

    this.dropdownRef = React.createRef();
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      isOpened: !prevState.isOpened,
    }));
  };

  handleChangeRemoveInsured(insuredIndex) {
    dataLayer.genericEvent('sg_event', 'sp_pagamento', 'click_botao', 'remover_segurados');
    this.props.removeInsuredForm(insuredIndex);
  }

  fmtIncomingName = (incoming) => {
    const incomingObj = incomingOptions.find((option) => option.value === incoming);
    return incomingObj ? incomingObj.name : incoming;
  };

  handleClickOutside = (e) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(e.target)) {
      this.setState({ isOpened: false });
    }
  };

  componentDidUpdate() {

    if (this.state.isOpened) {
      document.addEventListener('click', this.handleClickOutside);
    } else {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  render() {
    const errors = this.props.errors.insuredForms[this.props.index];
    const hasError = errors && (errors.name || errors.birth_date || errors.cpf || errors.passport || errors.incoming);

    return (
      <form action="" className={`form-segurados${hasError ? ' with-error' : ''}`}>
        {this.props.canDelete && (
          <button className="delete-insured mobile" onClick={() => this.props.removeInsuredForm(this.props.index)}>
            Remover
          </button>
        )}

        <div className={`form-segurados-input${errors && errors.name ? ' input-with-error' : ''}`}>
          <input
            type="text"
            maxLength={128}
            name="name"
            value={this.props.name}
            onChange={(e) => this.props.handleChange(e, this.props.index)}
            placeholder="Nome completo"
            onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'name', this.props.index)}
            className={`${errors && errors.name ? 'form-segurados-input-error' : ''}`}
          />

          <ErrorMessage
            anchor={`insuredForms_${this.props.index}_name`}
            field1="insuredForms"
            field2={this.props.index}
            field3="name"
            className="form-segurados-error"
          />
        </div>

        <div className={`form-segurados-input${errors && errors.birth_date ? ' input-with-error' : ''}`}>
          <MaskedInput
            guide
            name="birth_date"
            value={this.props.birth_date}
            type="tel"
            placeholder="Data de nascimento"
            keepCharPositions
            mask={[/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /[1-2]/, /\d/, /\d/, /\d/]}
            onChange={(e) => this.props.handleChange(e, this.props.index)}
            className={`${errors && errors.birth_date ? 'form-segurados-input-error' : ''}`}
            onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'birth_date', this.props.index)}
          />

          <ErrorMessage
            anchor={`insuredForms_${this.props.index}_birth_date`}
            field1="insuredForms"
            field2={this.props.index}
            field3="birth_date"
            className="form-segurados-error"
          />
        </div>

        <div className={`form-segurados-input${errors && errors.cpf ? ' input-with-error' : ''}`}>
          {this.props.destination === 'receptivo' && (
            <ul className="document-options">
              <li className="option">
                <input
                  type="radio"
                  id="cpf-option"
                  name="document_type"
                  value="cpf"
                  checked={this.props.document_type === 'cpf'}
                  onChange={(e) => this.props.handleChange(e, this.props.index)}
                />
                <label htmlFor="cpf-option">CPF</label>
              </li>
              <li className="option">
                <input
                  type="radio"
                  id="passaporte-option"
                  name="document_type"
                  value="passport"
                  checked={this.props.document_type === 'passport'}
                  onChange={(e) => this.props.handleChange(e, this.props.index)}
                />
                <label htmlFor="passaporte-option">Passaporte</label>
              </li>
            </ul>
          )}

          <MaskedInput
            placeholder={this.props.document_type === 'cpf' ? 'CPF' : 'Passaporte'}
            guide={this.props.document_type === 'cpf'}
            value={this.props[this.props.document_type] || ''}
            type="tel"
            mask={
              this.props.document_type === 'cpf'
                ? [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
                : [
                    /[A-Za-z0-9]/,
                    /[A-Za-z0-9]/,
                    /[A-Za-z0-9]/,
                    /[A-Za-z0-9]/,
                    /[A-Za-z0-9]/,
                    /[A-Za-z0-9]/,
                    /[A-Za-z0-9]/,
                    /[A-Za-z0-9]/,
                    /[A-Za-z0-9]/,
                    /[A-Za-z0-9]/,
                    /[A-Za-z0-9]/,
                    /[A-Za-z0-9]/,
                  ]
            }
            name={this.props.document_type}
            onChange={(e) => this.props.handleChange(e, this.props.index)}
            onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, this.props.document_type, this.props.index)}
            style={{ textTransform: 'uppercase' }}
            className={`${errors && (errors.cpf || errors.passport) ? 'form-segurados-input-error' : ''}`}
          />

          <ErrorMessage
            anchor={`insuredForms_${this.props.index}_${this.props.document_type}`}
            field1="insuredForms"
            field2={this.props.index}
            field3={this.props.document_type}
            title="Obs: Crianças de 0 a 5 anos solicitamos que seja preenchido com o CPF do titular."
            textDecoration="underline"
            className="form-segurados-error"
          />
        </div>

        {this.props.destination === 'receptivo' && (
          <div
            className={`form-segurados-input${errors && errors.incoming ? ' input-with-error' : ''} `}
            ref={this.dropdownRef}
          >
            <div className={`form-segurados-input${errors && errors.incoming ? ' input-with-error' : ''} select-input`}>
              <input
                type="text"
                maxLength={128}
                name="incoming"
                value={this.fmtIncomingName(this.props.incoming)}
                placeholder="País de origem"
                className={`${errors && errors.incoming ? 'form-segurados-input-error' : ''} ${
                  this.state.isOpened ? 'form-segurados-cs-select-focus' : ''
                }`}
                onChange={(e) => {
                  this.props.handleChange(e, this.props.index);
                  this.setState({ isOpened: true });
                }}
                onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'incoming', this.props.index)}
                onClick={() => this.handleToggle()}
                ref={this.dropdownRef}
              />

              {this.state.isOpened && (
                <div className="form-segurados-cs-select">
                  <ul className="form-segurados-cs-select-list">
                    <li className="placeholder">Pais de origem</li>
                    {incomingOptions
                      .filter(
                        (option) =>
                          !this.props.incoming || option.name.toLowerCase().includes(this.props.incoming.toLowerCase())
                      )
                      .map((option, index) => (
                        <li
                          key={index}
                          className="option"

                          onClick={() => {
                            this.props.handleChange(
                              { target: { name: 'incoming', value: option.value } },
                              this.props.index
                            );
                            this.props.validatorHandlerBlur(option.value, 'incoming', this.props.index);
                            this.handleToggle();
                          }}
                        >
                          {option.name}
                        </li>
                      ))}
                    {incomingOptions.filter(
                      (option) =>
                        !this.props.incoming || option.name.toLowerCase().includes(this.props.incoming.toLowerCase())
                    ).length === 0 && (
                      <li className="fallback">
                        <span>Nenhum resultado encontrado para <b>"{this.props.incoming}"</b>.</span>
                      </li>
                    )}
                  </ul>
                </div>
              )}

              {!this.state.isOpened && (
                <React.Fragment>
                  <div className='tooltip-container'>
                    <img src="/assets/images/icons/tooltipCircle.svg" alt="Info" />
                    <div class="chat-bubble tooltip">
                      Informe o país de onde você está partindo para sua viagem ao Brasil.
                    </div>
                  </div>
                </React.Fragment>
              )}

              <ErrorMessage
                anchor={`insuredForms_${this.props.index}_incoming`}
                field1="insuredForms"
                field2={this.props.index}
                field3="incoming"
                className="form-segurados-error"
              />
            </div>
          </div>
        )}

        {this.props.canDelete && (
          <button className="delete-insured desktop" onClick={() => this.props.removeInsuredForm(this.props.index)}>
            <img alt="delete" src="/assets/images/icons/circleDelete.svg" />
          </button>
        )}
      </form>
    );
  }
}

export default InsuredForm;



// WEBPACK FOOTER //
// ./src/components/purchase/insured_register/InsuredForm.jsx